import axios from 'axios'
import { ElMessage } from 'element-plus'
import { getToken } from '@/utils/auth'
import { makeErrorHandle400 } from "@/views/error/400"
import { makeErrorHandle401 } from "@/views/error/401"
import { makeErrorHandle404 } from "@/views/error/404"
import { otherErrorHandle } from "@/views/error/other"
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  // timeout: 10000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  (config) => {
    // do something before request is sent
    if (getToken()) {
      // let each request carry token
      config.headers.Authorization = `Bearer ${getToken()}`
    }
    return config
  },
  (error) => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */
  (response) => {
    // 响应数据
    const res = response.data
    return res
  },
  (error) => {
    // for debug
   const errorCode = error.response.data.detail
    if (error.response.status === 400) {
      makeErrorHandle400(errorCode)
    } else if(error.response.status === 401){
      makeErrorHandle401(errorCode)
    }else if(error.response.status === 404){
      makeErrorHandle404(errorCode)
    }else{
      let errMsg = error.message
      if (error.response) {
        errMsg = error.response.data.detail
        ElMessage({
          type: 'error',
          message: errMsg,
          center: true
        })
      }
    }
    return Promise.reject(error)
  }
)
export default service
